import { render, staticRenderFns } from "./DimensionDelete.vue?vue&type=template&id=3e21f58f"
import script from "./DimensionDelete.vue?vue&type=script&lang=js"
export * from "./DimensionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports